// All winning lines on a 3x3 grid, as cell indexes in reading order:
//  0 | 1 | 2
//  3 | 4 | 5
//  6 | 7 | 8
const LINES = [
    [0, 1, 2], [3, 4, 5], [6, 7, 8], // rows
    [0, 3, 6], [1, 4, 7], [2, 5, 8], // columns
    [0, 4, 8], [2, 4, 6], // diagonals
];

/**
 * A cell counts as filled when it is the free cell or has a photo.
 */
function isFilled(cell, photos) {
    return cell.type === 'free' || photos.has(cell.id);
}

/**
 * Return the indexes of the cells that make up the bingo,
 * or an empty Set when there is no bingo (yet).
 */
export function winningCells(cells, photos, rule) {
    const filled = cells.map((cell) => isFilled(cell, photos));

    if (rule === 'line') {
        const winning = new Set();

        LINES
            .filter((line) => line.every((index) => filled[index]))
            .forEach((line) => line.forEach((index) => winning.add(index)));

        return winning;
    }

    // default rule: full card
    return filled.every(Boolean) ? new Set(cells.keys()) : new Set();
}

/**
 * Count how many task cells have a photo (the free cell is not a task).
 */
export function progress(cells, photos) {
    const tasks = cells.filter((cell) => cell.type === 'task');

    return {
        done: tasks.filter((cell) => photos.has(cell.id)).length,
        total: tasks.length,
    };
}
